module.exports = __webpack_public_path__ + "img/IMG_0695.ceeb52e5.jpg";